import { Circle, Triangle, Pentagon, Square } from "lucide-react";
import { statusMeta } from "../lib/format";

const SHAPES = { circle: Circle, triangle: Triangle, pentagon: Pentagon, square: Square };

export const StatusMark = ({ status, size = 13, className = "", labelOverride }) => {
  const meta = statusMeta(status);
  const Shape = SHAPES[meta.shape] || Square;
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-sans text-xs font-semibold uppercase tracking-wide ${className}`}
      style={{ color: meta.color }}
      data-testid={`status-${meta.shape}`}
      title={labelOverride || meta.label}
    >
      <Shape size={size} strokeWidth={1.5} fill={meta.color} color={meta.color} />
      <span>{labelOverride || meta.label}</span>
    </span>
  );
};
